import { formatChildrenMap } from './helpers'
import { frameworkComponents } from 'pages/Administration/constants'
import { PERMISSION_COLUMNS } from 'pages/Administration/components/Table/configs'
import { FIELDS_TABLE, PERMISSION_TABLE } from './constant'

export const scenarioColumns = (t) => [
  {
    checkboxSelection: true,
    headerName: t('RolesManagement.RolesColumn.Name'),
    headerTooltip: t('RolesManagement.RolesColumn.Name'),
    field: 'name',
    colId: 'name',
    filter: 'agTextColumnFilter',
    cellRenderer: 'agGroupCellRenderer',
    cellClass: 'group-link'
  }
]

const dynamicColDefs = (t) => {
  const {
    read,
    create,
    update,
    deletion,
    // import_: importPermission,
    // export: exportPermission
  } = PERMISSION_COLUMNS(t)
  const disabled = true

  return {
    [PERMISSION_TABLE]: [
      {
        headerName: t('ScenarioManagement.ScenarioOwner'),
        headerTooltip: t('ScenarioManagement.ScenarioOwner'),
        field: 'name',
        colId: 'name',
        filter: 'agTextColumnFilter'
      },
      read(disabled),
      create(disabled),
      update(disabled),
      deletion(disabled),
      // importPermission(disabled),
      // exportPermission(disabled)
    ],
    [FIELDS_TABLE]: [
      {
        headerName: t('RolesManagement.DocumentFieldsColumn.Name'),
        headerTooltip: t('RolesManagement.DocumentFieldsColumn.Name'),
        field: 'name',
        colId: 'name',
        filter: 'agTextColumnFilter'
      },
      read(disabled)
    ]
  }
}

// Definition of the most internal tables
const fieldDetails =
  (t, onCellClicked) =>
  ({ data }) => {
    const { id } = data
    const mapColDefs = dynamicColDefs(t)
    const colDef = mapColDefs[id]

    return {
      autoHeight: true,
      detailGridOptions: {
        columnDefs: colDef,
        frameworkComponents: frameworkComponents,
        defaultColDef: {
          autoSizeColumnsOnFirstRender: true,
          flex: 1
        },
        onCellClicked
      },
      getDetailRowData: ({ data, successCallback }) => {
        const { id, children } = data
        const formatFun = formatChildrenMap[id]
        const result = formatFun({ children, data })

        successCallback(result)
      }
    }
  }

// Definition of the first level of details
export const detailCellRendererParams = (t, onCellClicked) => ({
  masterDetail: true,
  isRowMaster: true,
  autoHeight: true,
  detailGridOptions: {
    columnDefs: [{ field: 'name', cellRenderer: 'agGroupCellRenderer' }],
    headerHeight: 0,
    masterDetail: true,
    defaultColDef: {
      autoSizeColumnsOnFirstRender: true,
      flex: 1
    },
    detailCellRendererParams: fieldDetails(t, onCellClicked)
  },
  getDetailRowData: ({ data: { children }, successCallback }) => {
    successCallback(children)
  }
})
